<template>
    <div class="layer-content common">
    	<div class="txt-type1 mgb10">
			"<em class="pc02">출결상품 구매</em> 또는 <em class="pc02">추가구매</em>"의 리더기, 태그 수량을 입력해주세요.
		</div>
		<div class="txt-type1 mgb10">
			결제가 완료된 후에는 리더기, 태그 수량을 변경 하실 수 없으십니다.
		</div>
        <div class="balance-sort-wrap">
        	<div class="balance-sort-con box-type04 mgr5">
        		<div class="__in">
            		<div class="entry-cho">
            			<div class="f-left pdt5">
	                        <label class="mgl10">
	                            <span class="box"></span>
	                            <span class="label-txt">출결상품 구매</span>
	                        </label>
            			</div>
            			<div class="f-right">
            				<button class="small _bt-white"
									@click="openOrderSeInfoPopup()">
								<span>자세히보기</span>
							</button>
            			</div>
            		</div>
        			<table class="tb-none">
        				<colgroup>
							<col style="width:13%" />
        					<col style="width:20%" />
        					<col style="width:*" />
        				</colgroup>
        				<tbody>
							<template v-if="orderInfo.payMean == '999'">
								<tr>
									<th colspan="2"
										style="border-bottom: 1px solid #e0e0e0;">안심등하원 신청 수량</th>
									<td style="border-bottom: 1px solid #e0e0e0;">
										<span>
											리더기 수량 :
											<input type="text"
												   class="mgl5"
												   style="width:40px; height:25px;line-height: 16px;"
												   maxlength="3"
												   @keydown="$onbiLib.onlyNumberKeydown()" v-model="orderInfo.detectorCnt"
												   @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;대,&nbsp;
											태그 수량 :
											<input type="text"
												   class="mgl5"
												   style="width:40px; height:25px;line-height: 16px;"
												   maxlength="3"
												   @keydown="$onbiLib.onlyNumberKeydown()" v-model="orderInfo.tagCnt"
												   @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;개
										</span>
									</td>
								</tr>
								<tr>
									<th colspan="2">납부금액</th>
									<td>{{$onbiLib.addComma(orderAmt)}}원</td>
								</tr>
								<tr v-if="orderInfo.detectorCnt == 0&&orderInfo.tagCnt == 0">
									<td colspan="3">
									<span class="txt-type4">
										리더기 수량 또는 태그 수량을 먼저 입력해주세요.
									</span>
									<br/>
									<span class="txt-type4">
										출결상품 구매 시 리더기 , 태그 수량을 필수로 입력해주셔야 합니다.
									</span>
									</td>
								</tr>
								<template v-if="orderInfo.detectorCnt > 0||orderInfo.tagCnt > 0">
									<tr>
										<th colspan="2">결제신청일</th>
										<td>
											<vue-datepicker ref="subsidyDatePicker"
															:type="'day'"
															:sel-callback-func="selSubsidyPayDtCallbackFunc"
															:set-date="orderInfo.payDueDt"
															:set-btn-class="'_bt-ic11'"
											></vue-datepicker>
										</td>
									</tr>
									<tr>
										<th colspan="2">납부방법</th>
										<td>
											<input type="radio"
												   id="paymthdCdrdi01"
												   name="paymthdCdrdi01"
												   v-model="orderInfo.paymthdCd"
												   value="P02"/>
											<label for="paymthdCdrdi01" class="mgl0">
												<span class="box"></span>
												<span class="label-txt">&nbsp;신용(체크) 카드</span>
											</label>
											<input type="radio"
												   id="paymthdCdrdi02"
												   name="paymthdCdrdi02"
												   v-model="orderInfo.paymthdCd"
												   value="P04"/>
											<label for="paymthdCdrdi02">
												<span class="box"></span>
												<span class="label-txt">&nbsp;무통장 입금</span>
											</label>
										</td>
									</tr>
									<tr>
										<th colspan="2">납부정보</th>
										<td>
											<template v-if="orderInfo.paymthdCd == 'P04'">
												<div class="box-type05">
													<table class="tb-none" style="padding:0 10px;">
														<colgroup>
															<col style="width:35%;" />
															<col style="width:*" />
														</colgroup>
														<tbody>
															<tr>
																<th>영업사</th>
																<td>
																	<select class="select" style="width: 100% !important;" v-model="orderInfo.accSn">
																		<option v-for="(accInfo, index) in agencyAccList"
																				:key="'accInfo_'+index" :value="accInfo.accSn">{{accInfo.agencyNm}}</option>
																	</select>
																</td>
															</tr>
															<template v-if="orderInfo.accSn != ''">
															<tr>
																<th>은행/계좌번호</th>
																<td>
																	{{orderAccInfo.bankNm}} / {{orderAccInfo.accNo}}
																</td>
															</tr>
															<tr>
																<th>예금주명</th>
																<td>
																	{{orderAccInfo.accNm}}
																</td>
															</tr>
															</template>
														</tbody>
													</table>
												</div>
												<ul class="mgt10 depth2">
													<li>견적서상의 계좌번호로 입금바랍니다.</li>
													<li class="txt-type4">입금자은 '사업자등록번호'로 입금해주시기 바랍니다.('-'제외)</li>
												</ul>
											</template>
											<template v-if="orderInfo.paymthdCd == 'P02'">
												<span class="txt-type4">
													신용(체크) 카드 를 선택 하신경우 마이페이지에서 <br/>
													&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;즉시 결제 하실수 있습니다.
												</span>
											</template>
										</td>
									</tr>
								</template>
							</template>
							<template v-if="orderInfo.payMean != '999'">
								<tr>
									<th style="border-bottom: 1px solid #e0e0e0;" colspan="2">안심등하원 신청 수량</th>
									<td style="border-bottom: 1px solid #e0e0e0;">
										<span>
											리더기 수량 : {{orderInfo.detectorCnt}}&nbsp;대,&nbsp;
											태그 수량 : {{orderInfo.tagCnt}}&nbsp;개
										</span>
									</td>
								</tr>
								<template v-if="orderInfo.payMean == '001'">
									<tr>
										<th colspan="2">결제 수량</th>
										<td>
											<span>{{ orderInfo.goodsInfoTxt }}</span>
										</td>
									</tr>
									<tr>
										<th colspan="2">결제 금액</th>
										<td>
											<span>{{$onbiLib.addComma(orderInfo.paymentAmount)}}원</span>
										</td>
									</tr>
									<tr>
										<th colspan="2">결제 일자</th>
										<td>
											<span>{{ orderInfo.paymentDe }}</span>
										</td>
									</tr>
									<tr>
										<th colspan="2">결제 방법</th>
										<td>
											<span>{{ orderInfo.paymentSeNm }}</span>
										</td>
									</tr>
								</template>
								<template v-if="orderInfo.payMean == '002'">
									<template v-if="orderInfo.detectorPayCmpltAt == 'Y'">
										<tr>
											<th rowspan="4"
												style="border-bottom: 1px solid #e0e0e0;">리더기<br/>결제</th>
											<th>수량</th>
											<td>
												<span>{{ orderInfo.detectorGoodsInfoTxt }}</span>
											</td>
										</tr>
										<tr>
											<th>금액</th>
											<td>
												<span>{{$onbiLib.addComma(orderInfo.detectorPaymentAmount)}}원</span>
											</td>
										</tr>
										<tr>
											<th>일자</th>
											<td>
												<span>{{ orderInfo.detectorPaymentDe }}</span>
											</td>
										</tr>
										<tr>
											<th style="border-bottom: 1px solid #e0e0e0;">방법</th>
											<td style="border-bottom: 1px solid #e0e0e0;">
												<span>{{ orderInfo.detectorPaymentSeNm }}</span>
											</td>
										</tr>
									</template>
									<template v-if="orderInfo.detectorPayCmpltAt == 'N'">
										<tr>
											<th style="border-bottom: 1px solid #e0e0e0;">리더기<br/>결제</th>
											<td colspan="2"
												style="border-bottom: 1px solid #e0e0e0;">
												<div>
													<span style="font-size: 14px;line-height: 18px;">
														결제 해야될 리더기 {{orderInfo.detectorCnt}}대 ( 결제금액 : {{$onbiLib.addComma(orderDetectorAmt)}}원 )
													</span>
												</div>
												<div>
													<span class="txt-type4">마이페이지에서 결제를 진행해주십시오.</span>
												</div>
											</td>
										</tr>
									</template>
									<template v-if="orderInfo.tagPayCmpltAt == 'Y'">
										<tr>
											<th rowspan="4"
												style="border-bottom: 1px solid #e0e0e0;">태그<br/>결제</th>
											<th>수량</th>
											<td>
												<span>{{ orderInfo.tagGoodsInfoTxt }}</span>
											</td>
										</tr>
										<tr>
											<th>금액</th>
											<td>
												<span>{{$onbiLib.addComma(orderInfo.tagPaymentAmount)}}원</span>
											</td>
										</tr>
										<tr>
											<th>일자</th>
											<td>
												<span>{{ orderInfo.tagPaymentDe }}</span>
											</td>
										</tr>
										<tr>
											<th style="border-bottom: 1px solid #e0e0e0;">방법</th>
											<td style="border-bottom: 1px solid #e0e0e0;">
												<span>{{ orderInfo.tagPaymentSeNm }}</span>
											</td>
										</tr>
									</template>
									<template v-if="orderInfo.tagPayCmpltAt == 'N'">
										<tr>
											<th style="border-bottom: 1px solid #e0e0e0;">태그<br/>결제</th>
											<td colspan="2"
												style="border-bottom: 1px solid #e0e0e0;">
												<div>
													<span style="font-size: 14px;line-height: 18px;">
														결제 해야될 태그 {{orderInfo.tagCnt}}개 ( 결제금액 : {{$onbiLib.addComma(orderTagAmt)}}원 )
													</span>
												</div>
												<div>
													<span class="txt-type4">마이페이지에서 결제를 진행해주십시오.</span>
												</div>
											</td>
										</tr>
									</template>
								</template>
								<tr>
									<td colspan="3">
										<span class="txt-type4">신청 수량과 결제 수량이 상이 할 경우 연락부탁드립니다.</span>
									</td>
								</tr>
							</template>
        				</tbody>
        			</table>
        		</div>
        	</div>
        	<div class="balance-sort-con box-type04 mgl5">
        		<!--<div style="position: absolute;background: #888; top:47px;right:0px;bottom:0px;left:10px;opacity: 0.3;z-index: 99;" v-if="!selfPayAt"></div>-->
        		<div class="__in">
        			<div class="entry-cho">
            			<div class="f-left pdt5">
	                        <label class="mgl10">
	                            <span class="box"></span>
	                            <span class="label-txt">추가구매</span>
	                        </label>
            			</div>
            			<div class="f-right">
            				<button class="small _bt-white" @click="openOrderSeInfoPopup()"><span>자세히보기</span></button>
            			</div>
            		</div>
        			<table class="tb-none">
        				<colgroup>
							<col style="width:13%" />
							<col style="width:20%" />
							<col style="width:*" />
        				</colgroup>
        				<tbody>
                <tr>
                  <th style="border-bottom: 1px solid #e0e0e0;" colspan="2">안심등하원 신청 수량</th>
                  <td style="border-bottom: 1px solid #e0e0e0;">
										<span>
											리더기 수량 : {{selfOrderInfo.detectorCnt}}&nbsp;대,&nbsp;
											태그 수량 : {{selfOrderInfo.tagCnt}}&nbsp;개
										</span>
                  </td>
                </tr>
                <template v-if="selfOrderInfo.payMean == '999'">
                  <tr>
                    <th colspan="2">납부금액</th>
                    <td>{{$onbiLib.addComma(selfAmt)}}원</td>
                  </tr>
                </template>
								<template v-if="selfOrderInfo.payMean != '999'">
									<tr>
										<th colspan="2">결제 금액</th>
										<td>
											<span>{{$onbiLib.addComma(selfOrderInfo.paymentAmount)}}원</span>
										</td>
									</tr>
								</template>
                <tr>
                  <th style="border-top: 1px solid #e0e0e0;" colspan="2">
                    추가구매 안내</th>
                  <td style="border-top: 1px solid #e0e0e0;">
										<span class="txt-type4">
										  리더기 또는 태그 추가 구매를 원하시면
                      <br/>[추가 주문] 탭에서 주문해주시기 바랍니다.
										</span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" class="__center">
                    <button class="big _bt-blue"
                            @click="moveAddOrderPage_click()">
                      <span>추가주문 바로가기</span>
                    </button>
                  </td>
                </tr>
        				</tbody>
        			</table>
        		</div>
        	</div>
        </div>
        <div class="btn-wrap center t-line mgt20">
            <button class="big _bt-white" @click="closePopup()">
                <span>취소</span>
            </button>
            <button class="big _bt-navy"
					v-if="orderInfo.payMean == '999'||selfOrderInfo.payMean == '999'"
					@click="btn_modifyTagClick()">
                <span>수정</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name : 'modifyTagOrderPoopup',
	props: ['param', 'index'],
    data : function(){
        return{
            orderInfo : new Array(),
            selfOrderInfo : new Array(),
            agencyAccList : new Array(),
            callBackFunc : null,
            defOrderInfo : {
                reqstSn : '',
                orderSe : '001',
                tagSe : 'NFC',
                detectorCnt : '0',
                tagCnt : '0',
                payDueDt : null,
                paymthdCd : '',
                billCardSn:'',
                cardNum:'',
                cardCode:'',
                cardBankCode:'',
				payMean: '999',
				accSn : '',
            },
            defSelfOrderInfo : {
                reqstSn : '',
                orderSe : '002',
                tagSe : 'NFC',
                detectorCnt : '0',
                tagCnt : '0',
                payDueDt : null,
                paymthdCd : 'P02',
                billCardSn:'',
                cardNum:'',
                cardCode:'',
                cardBankCode:'',
				payMean: '999',
				accSn : '',
            },
            cardRegOrderSe:''
        }
    },
    computed: {
        orderAmt : function(){
            const orderInfo = this.orderInfo;
            let detectorAmt = 0;
            /*if(orderInfo.detectorCnt > 1){
                detectorAmt = 300000*1 + 220000 * Number(orderInfo.detectorCnt-1);
            }else{
                detectorAmt = 300000 * Number(orderInfo.detectorCnt);
            }*/

			detectorAmt = 300000 * Number(orderInfo.detectorCnt);
            let tagAmt = Number(orderInfo.tagCnt) * 5000;
            return detectorAmt + tagAmt;
        },
		orderDetectorAmt : function(){
			const orderInfo = this.orderInfo;

			let tagAmt = Number(orderInfo.tagCnt) * 5000;
			return this.orderAmt - tagAmt;
		},
		orderTagAmt : function(){
			const orderInfo = this.orderInfo;
			let detectorAmt = 0;
			/*if(orderInfo.detectorCnt > 1){
				detectorAmt = (300000 * 1) + (220000 * Number(orderInfo.detectorCnt-1));
			}else{
				detectorAmt = 300000 * Number(orderInfo.detectorCnt);
			}*/
			detectorAmt = 300000 * Number(orderInfo.detectorCnt);
			return this.orderAmt - detectorAmt;
		},
        selfAmt : function(){
            /*const orderInfo = this.orderInfo;*/
            const selfOrderInfo = this.selfOrderInfo;
            let detectorAmt = 0;

            /*if(this.selfOrderInfo.detectorCnt > 0){
                if(Number(orderInfo.detectorCnt) > 0 ){
                    detectorAmt = 220000 * selfOrderInfo.detectorCnt;
                }else{
                    detectorAmt = (300000 * 1) + (220000 * Number(selfOrderInfo.detectorCnt-1));
                }
            }*/

			detectorAmt = 220000 * selfOrderInfo.detectorCnt;

            let tagAmt = Number(selfOrderInfo.tagCnt) * 5000;
            return detectorAmt + tagAmt;
        },
		selfDetectorAmt : function(){
			const selfOrderInfo = this.selfOrderInfo;

			let tagAmt = Number(selfOrderInfo.tagCnt) * 5000;
			return this.selfAmt - tagAmt;
		},
		selfTagAmt : function(){
			/*const orderInfo = this.orderInfo;*/
			const selfOrderInfo = this.selfOrderInfo;
			let detectorAmt = 0;

			/*if(this.selfOrderInfo.detectorCnt > 0){
				if(Number(orderInfo.detectorCnt) > 0 ){
					detectorAmt = 220000 * selfOrderInfo.detectorCnt;
				}else{
					detectorAmt = 300000*1 + 220000 * Number(selfOrderInfo.detectorCnt-1);
				}
			}*/

			detectorAmt = 220000 * selfOrderInfo.detectorCnt;

			return this.selfAmt - detectorAmt;
		},
        mberInfo : function(){
            return this.$store.getters.getMberInfo;
        },
        dayInfo : function(){
            return this.$store.getters.getDayInfo;
        },
		modifyPssbleAt: function(){
        	let pssbleAt = true;

        	return pssbleAt;
		},
		orderAccInfo : function(){
			const accSn = this.orderInfo.accSn;
			const accInfo = this.agencyAccList.find(function(info){
				return info.accSn == accSn;
			});

			console.log(accInfo);
			return accInfo;
		},
		selfAccInfo : function(){
			const accSn = this.selfOrderInfo.accSn;
			const accInfo = this.agencyAccList.find(function(info){
				return info.accSn == accSn;
			});

			return accInfo;
		}
    },
    methods : {
        openOrderSeInfoPopup : function(){
            const popupInfo = {
                se:'modal',
                id:'orderSeInfoPopup',
                wid:'670',
                hei:'',
                tit:'정산 구분 안내',
                draggableAt:false,
            };

            this.$store.commit('openPopup',popupInfo);
        },
        btn_modifyTagClick : function(){
            this.updateTagOrder();
        },
        btn_regPayCardClick: function(orderSe){
            this.cardRegOrderSe = orderSe;
            let billCardSn = this.orderInfo.billCardSn;
            if(this.cardRegOrderSe == '002'){
                billCardSn = this.selfOrderInfo.billCardSn;
            }

            const _this = this;

            this.searchBillCardList().then(function(billCardList){
                if(billCardList.length > 0){
                    const param = {
                        billCardSn : billCardSn,
                        billCardList : billCardList,
                        regNewBillCardFunc:_this.regNewBillCard,
                        regBillCardFunc:_this.regBillCard
                    }

                    const popupInfo = {
                        se:'modal',
                        id:'billCardListPopup',
                        wid:'860',
                        hei:'',
                        tit:'결제 카드 등록',
                        draggableAt:false,
                        param:param
                    };

                    _this.$store.commit('openPopup',popupInfo);
                }else{
                    _this.regNewBillCard();
                }
            }).catch(function (e) {
                console.log(e);
                _this.$toasted.show(_this.$onbiLib.msg.err.system);
            });
        },
        searchBillCardList : function(){
            const _this = this;
            return new Promise(function (resolve, reject) {
                _this.axios.post('/i5gam/srvc/searchBillCardList.act',{
                    mberNo : _this.mberInfo.mberNo
                }).then(function(response) {
                    resolve(response.data.billCardList);
                }.bind(this)).catch(function(e) {
                    reject(e);
                });

            });
        },
        regBillCard: function(billCardInfo){
            this.saveBillCardInfo(billCardInfo,"up");
        },
        regNewBillCard: function(){
            let amount = this.orderAmt;
            if(this.cardRegOrderSe == '002'){
                amount = this.selfAmt;
            }

            var param={
                procSe: 'getBillCardInfo',
                reqstSn: this.param.reqstSn,
                goodsCd: '',
                goodsNm: '아이오감',
                goodsMtAmount: amount,
                goodsYearAmount: amount,
                payTypeCd: 'PT1',
                paymthdCd: 'P02',
                fcltcd: this.param.fcltcd,
                mberNo: this.mberInfo.mberNo,
                mberNm: this.mberInfo.mberNm,
                cttpc: this.mberInfo.cttpc,
                email: this.mberInfo.email,
                reqDefrayDe: 20,
                rm: '마이페이지 결제 수단변경',
                callBackFunc:this.saveBillCardInfo
            };

            const popupInfo = {
                se:'modalBlank',
                id:'iniPayReqBillPopup',
                wid:'820',
                hei:'600',
                tit:'이니시스결제',
                draggableAt:false,
                param:param
            };

            this.$store.commit('openPopup',popupInfo);
        },
        saveBillCardInfo:function(billCardInfo,se){
			const _this = this;
			let saveSe = "new";
			if(se == "up"){
				saveSe = se;
			}

			if(saveSe == 'new'){
				this.axios.post('/i5gam/srvc/saveMberBillCardInfoProc.act',{
					saveSe: saveSe,
					mberNo: this.mberInfo.mberNo,
					billCardInfo:billCardInfo
				}).then(function(response) {
					const procInfo = response.data.procInfo;
					if(procInfo.procCode == "000"){
						this.setBillCardInfo(procInfo.billCardInfo);
					}else{
						this.$toasted.show(this.$onbiLib.msg.err.system);
					}
				}.bind(this)).catch(function(e) {
					console.log(e);
					_this.$toasted.show(_this.$onbiLib.msg.err.system);
				});
			}else{
				this.setBillCardInfo(billCardInfo);
			}

        },
		setBillCardInfo: function(billCardInfo){
			if(this.cardRegOrderSe == '001'){
				this.orderInfo.billCardSn   = billCardInfo.billCardSn;
				this.orderInfo.cardNum      = billCardInfo.cardNum;
				this.orderInfo.cardCode     = billCardInfo.cardCode;
				this.orderInfo.cardBankCode = billCardInfo.cardBankCode;
			}else if(this.cardRegOrderSe == '002'){
				this.selfOrderInfo.billCardSn   = billCardInfo.billCardSn;
				this.selfOrderInfo.cardNum      = billCardInfo.cardNum;
				this.selfOrderInfo.cardCode     = billCardInfo.cardCode;
				this.selfOrderInfo.cardBankCode = billCardInfo.cardBankCode;
			}

			this.$store.commit('closePopup',1);
		},
        chkValid : function(){
			if(this.orderInfo.detectorCnt == 0&&this.orderInfo.tagCnt > 0){
				this.$toasted.show('출결상품 구매 시 리더기 필수 입력 사항입니다.');
				return true;
			}else if(this.orderInfo.detectorCnt == 0&&this.orderInfo.tagCnt == 0){
				this.$toasted.show('출결상품 구매 시 리더기 또는 태그 수량은 필수 입력 사항입니다.');
				return true;
			}

            if(this.orderInfo.detectorCnt > 0||this.orderInfo.tagCnt > 0){
                if(this.orderInfo.payDueDt == ''){
					this.$toasted.show("출결상품 구매 시 결제신청일을 선택해주세요.");
                    return true;
                }

                if(this.orderInfo.paymthdCd == ''){
					this.$toasted.show("출결상품 구매 시 납부방법을 선택해주세요.");
                    return true;
                }
            }

			if(this.selfOrderInfo.detectorCnt > 0||this.selfOrderInfo.tagCnt > 0){
                if(this.selfOrderInfo.payDueDt == ''){
					this.$toasted.show('추가구매 결제신청일을 선택해주세요.');
                    return true;
                }

                if(this.selfOrderInfo.paymthdCd == ''){
					this.$toasted.show('추가구매 납부방법을 선택해주세요.');
                    return true;
                }
            }

            return false;
        },
        updateTagOrder : function(){
			if(this.chkValid()) return false;

			if(this.selfOrderInfo.detectorCnt == 0&&this.selfOrderInfo.tagCnt == 0){
				this.selfOrderInfo.payDueDt = null;
				this.selfOrderInfo.billCardSn = null;
			}

            const _this = this;

			this.axios.post('/i5gam/srvc/updateTagOrder.act',{
                orderInfo : this.orderInfo,
                selfOrderInfo : this.selfOrderInfo,
                mberNo : this.mberInfo.mberNo
            }).then(function() {
				this.closePopup();
				this.callBackFunc();
            }.bind(this)).catch(function(e) {
                console.log(e);
                _this.$toasted.show(_this.$onbiLib.msg.err.system);
            });
        },
        selSubsidyPayDtCallbackFunc : function(date){
            this.orderInfo.payDueDt = date;
        },
        selSelfPayDtCallbackFunc : function(date){
            this.selfOrderInfo.payDueDt = date;
        },
        closePopup : function(){
            this.$store.commit('closePopup', this.index);
		},
		searchAgencyAccList : function(){
			const _this = this;

			return new Promise(function(resolve, reject){
				_this.axios.post('/i5gam/srvc/searchAgencyAccList.act',{
				}).then(function(response) {
					resolve(response.data.agencyAccList);
				}.bind(this)).catch(function(e) {
					reject(e);
				});
			})
		},
    moveAddOrderPage_click : function (){
      this.closePopup();
      this.param.tabClickFunc('003');
    }
    },
    mounted : function(){
		const _this = this;
		this.searchAgencyAccList().then(function(agencyAccList){
			agencyAccList.splice(0,0,{accSn:'', agencyNm : '선택'});
			_this.agencyAccList = agencyAccList;
			_this.callBackFunc = _this.param.callBackFunc;
			const orderInfo = JSON.parse(JSON.stringify(_this.param.orderInfo));
			const selfOrderInfo = JSON.parse(JSON.stringify(_this.param.selfOrderInfo));

			if(orderInfo != null){
				_this.orderInfo = orderInfo;
			}else{
				_this.orderInfo = JSON.parse(JSON.stringify(_this.defOrderInfo));
				_this.orderInfo.reqstSn = _this.param.reqstSn;
			}

			if(selfOrderInfo != null){
				if(selfOrderInfo.detectorCnt == 0&&selfOrderInfo.tagCnt == 0){
					selfOrderInfo.payDueDt = null;
					selfOrderInfo.billCardSn = '';
					selfOrderInfo.cardNum = '';
					selfOrderInfo.cardCode = '';
					selfOrderInfo.cardBankCode = '';
				}

				_this.selfOrderInfo = selfOrderInfo;
			}else{
				_this.selfOrderInfo = JSON.parse(JSON.stringify(_this.defSelfOrderInfo));
				_this.selfOrderInfo.reqstSn = _this.param.reqstSn;
			}
		});
    }
}
</script>
